/**
 * API configuration constants
 */
export const API_CONFIG = {
  MAX_PROMPT_LENGTH: 10000,
  TRACE_ENABLED: true,
} as const;

/**
 * Error detection patterns
 */
export const ERROR_PATTERNS = {
  PARAMETER_VALIDATION: 'Parameter validation failed',
  INVALID_KEY_TYPE: 'Invalid type for parameter Key',
  TIMEOUT_MESSAGES: ['timeout'],
  NETWORK_ERROR_MESSAGE: 'Network Error',
  CANCELED_ERROR_NAMES: ['CanceledError', 'AbortError'],
  CANCELED_ERROR_MESSAGES: ['canceled', 'aborted'],
  // Emitted by core_api when a guided journey's instructions cannot be loaded.
  // It refuses to invoke the agent in that case rather than let it improvise,
  // so this needs its own message: the generic one would not tell the user that
  // nothing ran. Must stay in step with JOURNEY_PROMPT_UNAVAILABLE in
  // srv/src/core_api/services/aws_agentcore_runner_service.py.
  JOURNEY_PROMPT_UNAVAILABLE: 'JOURNEY_PROMPT_UNAVAILABLE',
} as const;
